// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero--hero--3mXx1","lastRow":"Hero--lastRow--sfh0T","courses":"Hero--courses--3a9zE","item":"Hero--item--3Felv","items":"Hero--items--6ZdnB"};